<template>
  <div :style="loginStyle" class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 justify-content-center">
      <b-col lg="11" class="pt-5 pl-3">
        <InitialHeader :onlyLogo="true" />
      </b-col>
      <b-col
          sm="12"
          md="12"
          lg="11"
          class="d-flex align-items-center mb-5"
      >
        <b-col
            sm="12"
            md="10"
            lg="4"
            class="mx-auto auth-bg p-2 rounded"
        >
          <div id="verificar-email" class="px-xl-3 pb-1 pt-3">
            <h2 class="mb-1 auth-title">
              Verifique suas informações
            </h2>
            <p class="text-muted mb-2">
              Se encontrarmos seu e-mail, enviaremos as instruções para redefinir a senha.
            </p>
            <p class="text-muted mb-2">
              Não recebeu um e-mail? Verifique também a sua caixa de spam ou
              <b-link @click="actionResendInstructions">
                reenvie!
              </b-link>
            </p>
          </div>

          <div class="px-xl-3 pt-1 pb-3">
            <p class="text-center mt-2">
              <b-link :to="{name:'public-login'}">
                <feather-icon icon="ChevronLeftIcon" size="16" />
                <span class="to-login">&nbsp;Volte ao Login</span>
              </b-link>
            </p>
          </div>
        </b-col>
      </b-col>
      <FooterInitial />
    </b-row>
  </div>
</template>

<script>
import {
  BCol,
  BLink,
  BRow,
} from 'bootstrap-vue'
import FooterInitial from '@/views/components/custom/footer/FooterInitial.vue'
import InitialHeader from '@/views/components/custom/page-header/InitialHeader.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/libs/api'
import rotasAPI from '@/router/rotasAPI'

export default {
  name: 'PublicCpfSent',
  components: {
    BCol,
    BLink,
    BRow,
    FooterInitial,
    InitialHeader,
  },
  props: ['cpf'],
  data() {
    return {
      emailSent: this.cpf,
      loginStyle: {
        'background-image': `url(${require('@/assets/custom-images/bg/bg-login.png')})`,
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
      },
    }
  },

  methods: {
    async actionResendInstructions() {
      if (this.emailSent) {
        const email = this.emailSent.trim()
        
        try {
          await api.post(rotasAPI.acessoPublicoRecuperarSenha(email))
          
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Instruções reenviadas!',
              icon: 'MailIcon',
              text: 'Se encontrarmos seu e-mail, enviaremos as instruções para redefinir a senha.',
              variant: 'success',
            },
          }, {
            timeout: 8000,
          })
        } catch (error) {
          console.error(error)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao reenviar',
              icon: 'AlertCircleIcon',
              text: 'Não foi possível reenviar as instruções. Tente novamente.',
              variant: 'danger',
            },
          }, {
            timeout: 8000,
          })
        }
        return
      }

      this.$router.push({ name: 'public-forgot-password' })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
